import { useCalculatedResults } from '@react-query/hooks/use-calculated-results';
import { useTranslation } from '@translations';
import { PanelHeader } from '../panel-header/panel-header';
import { DataChart } from './data-chart/data-chart';

export const DataChartPanel = () => {
    const { developmentOverTime } = useTranslation();
    const { isFetching } = useCalculatedResults();

    return (
        <section className="data-chart-panel">
            <PanelHeader title={developmentOverTime} showIsLoading={isFetching} />
            <div className="data-chart-panel__chart-container" aria-hidden="true">
                <DataChart />
            </div>
        </section>
    );
};
